var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 389,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513,
    y: 857,
    width: 357,
    height: 389
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-513 -857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546 1030.5C546 952.904 608.68 890 686 890 763.32 890 826 952.904 826 1030.5 826 1108.1 763.32 1171 686 1171 608.68 1171 546 1108.1 546 1030.5Z",
    fill: "#C74EB0",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 183,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 624.173 1093)"
  }, "R"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.eb4322f95a68fcce8f559684431030ca.svg";
export { ForwardRef as ReactComponent };